import { LoadAssetChartUsecase, LoadAssetChartUsecaseImp } from 'domain/usecases/load-asset-chart-usecase';
import { makeLoadAssetChartHttpRepository } from '../repositories/http/asset-chart-http-repository-factory';

export const makeLoadAssetChartUsecase = (): LoadAssetChartUsecase => {
  return new LoadAssetChartUsecaseImp(makeLoadAssetChartHttpRepository());
};
